import { CommonModule } from "@angular/common";
import { Injector, NgModule } from "@angular/core";

import { defineCustomElements } from "@dffedb/util";


import { DffedbFancyboxComponent } from "./dffedb-fancybox.component";

@NgModule({
    imports: [CommonModule, DffedbFancyboxComponent],
    exports: [DffedbFancyboxComponent],
    providers: []
})
export class DffedbFancyboxModule {
    constructor(injector: Injector) {
        defineCustomElements("dffedb-fancybox", DffedbFancyboxComponent, { injector });
    }
}
